// extracted by mini-css-extract-plugin
module.exports = {"pill":"DecorarPhotoPill_pill__TjANL","label":"DecorarPhotoPill_label__d_oas"};